import { oAuthSignInRequest as signIn } from './o-auth-sign-in.request';

export const oAuthRequests = (fetchApi) => ({
  signIn: signIn(fetchApi),
});
